// React
import { PropsWithChildren, createContext, useState } from "react"

// Types
export interface CompanyType {
  company_name: string
  type_industry_name: string
}

// Vars
const defaultCompany: CompanyType = {
  company_name: "",
  type_industry_name: ""
}

export const CompanyContext = createContext<{
  company: CompanyType
  assignCompany: (value: CompanyType) => void
}>({
  company: defaultCompany,
  assignCompany(_) {},
})

export function CompanyProvider(params: PropsWithChildren<{}>): JSX.Element {
  // Hooks
  const [company, setCompany] = useState<CompanyType>(defaultCompany)

  // Functions
  const assignCompany = (company: CompanyType) => {
    setCompany(company)
  }

  return (
    <CompanyContext.Provider value={{ company, assignCompany }}>
      {params.children}
    </CompanyContext.Provider>
  )
}